export default {
  id: '',
  name: '',
  mail: '',
  access_token: '',
  admin: false,
  contract_id: '',
  contractor_name: ''
}



// WEBPACK FOOTER //
// ./src/store/User.js